export const DROPDOWN_TOGGLE_ICON = "fa-solid fa-caret-down";
export const MOBILE_HEADER_NAV_ICON = "fa-solid fa-bars";
export const ACCORDION_ICON = "fa-solid fa-greater-than";